import unigramsAndBigrams from './unigramsAndBigrams';

const { bigrams } = unigramsAndBigrams;

export default bigrams;
